import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "../../providers/ContextProvider";
import AddGoalCard from "../../components/AddGoalCard";
import { FaPlus } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import "../../styles/general.css";
import "../../styles/queries.css";
import "../../styles/SetGoals.css";
import axios from "axios";

function SetGoals() {
  const initializedGoal = {
    habitName: "",
    unit: "",
    weight: "",
  };
  const [goals, setGoals] = useState([initializedGoal]);
  const { state, dispatch } = useData();
  const navigate = useNavigate();
  function inputChangeHandler(e, index) {
    let goal = goals[index];
    let newGoal = { ...goal, [e.target.name]: e.target.value };
    let newGoals = [...goals];
    newGoals.splice(index, 1, newGoal);
    setGoals([...newGoals]);
  }

  async function submitHandler(e) {
    e.preventDefault();

    const userID = JSON.parse(localStorage?.getItem("userID"));
    const token = JSON.parse(localStorage?.getItem("token"));
    let result = await axios
      .post(
        `http://localhost:5000/goals/${userID}`,
        { goals },
        {
          headers: { token },
        }
      )
      .catch((error) => {
        console.error(error);
      });

    if (result?.data?.success) {
      dispatch({ type: "SETGOALS", payload: result.data.goals });
      navigate("/app/view-goals");
    }
  }

  return (
    <main className="main">
      <div className="form-container set-goal-form-container">
        <h3 className="tertiary-heading form-heading">
          <FaRegStar />
          Set Goal
        </h3>
        <div className="divider"></div>
        <form
          className="form set-goal-form"
          onSubmit={submitHandler}
          method="post"
        >
          <p>
            Add the habit you'd like to track For eg. If you'd like to track
            hours you spend reading and for each hour spent reading you'd like
            to give yourself 2 points, then fill: "Reading","hour/hours","2"
            respectively.
          </p>
          {goals.map((goal, index) => {
            const { habitName, unit, weight } = goal;
            return (
              <AddGoalCard
                habitName={habitName}
                unit={unit}
                weight={weight}
                index={index}
                inputChangeHandler={inputChangeHandler}
                key={index}
              />
            );
          })}
          <button
            className="btn btn-plus"
            onClick={() => setGoals((goals) => [...goals, initializedGoal])}
          >
            <FaPlus />
          </button>
          <button type="submit" className="btn btn-fill">
            Add Habits
          </button>
        </form>
      </div>
    </main>
  );
}

export default SetGoals;
